import { filters, API_INFINITY_VALUE, FILTER_TYPE } from '../../../constants';
import type { CustomCompanyFilter } from '../filters';

import { dots } from '../../../functions';

export const generateDividendsFilters = (): CustomCompanyFilter[] => [
  {
    id: filters.currentDividend,
    label: 'Dividend Yield',
    labels: {
      ...dots(10),
      0: '0%',
      10: '10%',
      12: '∞',
    },
    softMax: 10,
    min: 0,
    max: 12,
    type: FILTER_TYPE.RANGE,
    defaultValue: `["${filters.currentDividend}", "between", 0, 10]`,
    rule: (range) => {
      if (range instanceof Array) {
        const [min, max] = range;
        return `["${filters.currentDividend}", "between", ${min}, ${max}]`;
      }
      return '';
    },
    valueResolver: (range) =>
      range.map((value) => (value > 10 ? API_INFINITY_VALUE : value)),
    titleFormatter: ([_, __, min, max]) =>
      `is between ${min}% and ${
        Number(max) >= API_INFINITY_VALUE ? '∞' : `${max}%`
      }`,
  },
  {
    id: filters.upcomingDividend,
    label: 'Only show companies with an upcoming dividend payment',
    rule: `["${filters.upcomingDividend}", "=", 1]`,
    defaultValue: `["${filters.upcomingDividend}", "=", 1]`,
  },
];
